import React from 'react';
import PropTypes from 'prop-types';
import { WHITE } from '../config/colors';

function ListIcon({ color, style }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="512pt"
      height="512pt"
      viewBox="0 -52 512 512"
      style={style}
    >
      <path fill={color || WHITE} d="M0 0h113.293v113.293H0zm0 0M149.297 0H512v113.293H149.297zm0 0M0 147.008h113.293V260.3H0zm0 0M149.297 147.008H512V260.3H149.297zm0 0M0 294.012h113.293v113.297H0zm0 0M149.297 294.012H512v113.297H149.297zm0 0" />
    </svg>
  );
}

ListIcon.propTypes = {
  color: PropTypes.string.isRequired,
  style: PropTypes.objectOf({}).isRequired,
};

export default ListIcon;



// WEBPACK FOOTER //
// ./src/icons/ListIcon.jsx